import { configuredDayjs as dayjs } from 'utils/dayjs-setup';

import { MOVE_IN_VERIFY_ERROR_CODES } from 'config/app-config';
import {
  FUEL_TYPES,
  METER_TYPES,
  DATE_FORMAT,
  DATE_FORMAT_FOR_DISPLAY
} from 'config/app-config';

import type { TMeter } from 'api/models/TMeter';
import type { TProduct } from 'api/models/TProduct';

export const getFuelType = ({ gas, electric }) => {
  switch (true) {
    case gas && electric:
      return 'dual';
    case gas:
      return FUEL_TYPES.GAS;
    default:
      return FUEL_TYPES.ELECTRIC;
  }
};

export const hasSmartMetter = (
  { electric, gas },
  electricityMeter: TMeter = {},
  gasMeter: TMeter = {}
) => {
  const isDualFuel = electric && gas;
  const hasGasSmartMeter =
    gasMeter.smetsVersion === METER_TYPES.S1 ||
    gasMeter.smetsVersion === METER_TYPES.S2;
  const hasElectricitySmartMeter =
    electricityMeter.smetsVersion === METER_TYPES.SMETS1 ||
    electricityMeter.smetsVersion === METER_TYPES.SMETS2;
  const hasDualSmartMeter = hasElectricitySmartMeter && hasGasSmartMeter;

  switch (true) {
    case isDualFuel:
      return {
        hasElectricitySmartMeter,
        hasGasSmartMeter,
        hasAllSmartMeter: hasDualSmartMeter
      };
    case electric:
      return {
        hasElectricitySmartMeter,
        hasAllSmartMeter: hasElectricitySmartMeter
      };
    case gas:
      return {
        hasGasSmartMeter,
        hasAllSmartMeter: hasGasSmartMeter
      };
    default:
      return {};
  }
};

export const getTariffEndDate = (product?: TProduct) => {
  if (!product) {
    return null;
  }

  const { gasTil, electricityTil } = product;
  const tariff = gasTil || electricityTil;
  return tariff?.tariffEndsOn;
};

export const formatTariffDate = (date?: string | null) =>
  dayjs(date, DATE_FORMAT).format('Do MMMM YYYY');

export const formatDate = (date: string | null, originalFormat = DATE_FORMAT) =>
  dayjs(date, originalFormat).format(DATE_FORMAT_FOR_DISPLAY);

export const filterFeaturesByTitle = (
  features: TProduct['features'] = [],
  excludeTitles: string[] = []
) => {
  return features?.filter(({ title = '' }) => {
    return !excludeTitles.includes(title);
  });
};

export const getFeaturesByTitle = (
  features: TProduct['features'] = [],
  titles: string[] = []
) => {
  return features.filter(({ title: featureTtitle = '' }) =>
    titles.includes(featureTtitle)
  );
};

export const isUneligibleMoveInError = (error) =>
  error?.code === MOVE_IN_VERIFY_ERROR_CODES.NotEligibleForMoveInError;
